/**
 * @generated SignedSource<<214e8b7ea3945f79599d8316ec480420>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productSidePanelContent_UnassignShapesMutation$variables = {
  printTypesIds: ReadonlyArray<string>;
  productsIds: ReadonlyArray<string>;
};
export type productSidePanelContent_UnassignShapesMutation$data = {
  readonly assignShapes: boolean;
};
export type productSidePanelContent_UnassignShapesMutation = {
  response: productSidePanelContent_UnassignShapesMutation$data;
  variables: productSidePanelContent_UnassignShapesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "printTypesIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productsIds"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "printTypesIds",
        "variableName": "printTypesIds"
      },
      {
        "kind": "Variable",
        "name": "productsIds",
        "variableName": "productsIds"
      }
    ],
    "kind": "ScalarField",
    "name": "assignShapes",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_UnassignShapesMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "productSidePanelContent_UnassignShapesMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "b3c110cd8ef64c680df7a9dc44491a0e",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_UnassignShapesMutation",
    "operationKind": "mutation",
    "text": "mutation productSidePanelContent_UnassignShapesMutation(\n  $productsIds: [ID!]!\n  $printTypesIds: [ID!]!\n) {\n  assignShapes(productsIds: $productsIds, printTypesIds: $printTypesIds)\n}\n"
  }
};
})();

(node as any).hash = "49155518e9ec59a0243848d3eee879f1";

export default node;
